module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Display2-40129a7a316eb6b8376baba86c31eee7.svg";